module.exports = __webpack_public_path__ + "img/coconut-mint-collins.89645171.jpg";